import React, { createRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isEmpty } from 'lodash';

import { Grid } from '~/components';
import api from '~/services/api';
import {
  storeInRequest,
  recordFiltering,
  resetFiltering,
} from '~/store/modules/estoqueproduto/actions';

import { Graph, RefreshStock } from './components';

export default function EstoqueProduto() {
  const estoqueProduto = useSelector((state) => state.estoqueproduto);

  const [posto, setPosto] = useState(false);
  const [combo, setCombo] = useState([]);

  const refStock = createRef();

  async function handleTogglePostoComboio() {
    const { data } = await api.get('postoscomboios', {
      params: { pagesize: 99999, pesquisalista: true },
    });

    await setCombo(data.items);
  }

  async function handleToggleCombo(value) {
    await setPosto(false);

    if (!isEmpty(value.combo)) {
      await setPosto(value.combo.idposto);
    }
  }

  useEffect(() => {
    handleTogglePostoComboio();
  }, []);

  return (
    <>
      <Grid
        state={estoqueProduto}
        read={storeInRequest}
        filter={recordFiltering}
        reset={resetFiltering}
        timeOut={300000}
        component={(props) => (
          <Graph
            {...props}
            refresh={(product) => refStock.current.handleToggleModal(product)}
          />
        )}
        unique={{
          wherefield: 'idposto',
          valuewherefield: posto,
          typewherefield: 'EQUALS',
        }}
        toolbar={[
          {
            type: 'select',
            name: 'combo',
            options: combo,
            label: 'nomeposto',
          },
        ]}
        changeToolbar={(value) => handleToggleCombo(value)}
        onStart={!!posto}
      />

      <RefreshStock ref={refStock} />
    </>
  );
}
